/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type { Teams, TeamsInterface } from "../../contracts/Teams";

const _abi = [
  {
    inputs: [],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "previousAdmin",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "newAdmin",
        type: "address",
      },
    ],
    name: "AdminChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "beacon",
        type: "address",
      },
    ],
    name: "BeaconUpgraded",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint8",
        name: "version",
        type: "uint8",
      },
    ],
    name: "Initialized",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "user",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "teamPlanId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "member",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "teamMembers",
        type: "uint256",
      },
    ],
    name: "MemberAdded",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "previousAdminRole",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "newAdminRole",
        type: "bytes32",
      },
    ],
    name: "RoleAdminChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleGranted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleRevoked",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "subscriber",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "teamPlanId",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "timestamp",
        type: "uint256",
      },
    ],
    name: "Subscribed",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "user",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "teamPlanId",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "teamCount",
        type: "uint256",
      },
    ],
    name: "TeamFilled",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "teamPlanId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "isActive",
        type: "bool",
      },
    ],
    name: "TeamPlanActivityChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "teamPlanId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "subscriptionCost",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "reward",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "stakingThreshold",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "teamSize",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "stakingPlanId",
        type: "uint256",
      },
    ],
    name: "TeamPlanCreated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "implementation",
        type: "address",
      },
    ],
    name: "Upgraded",
    type: "event",
  },
  {
    inputs: [],
    name: "DEFAULT_ADMIN_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "SUBSCRIPTION_PERIOD_DAYS",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "UPGRADER_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "subscriptionCost_",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "reward_",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "stakingThreshold_",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "teamSize_",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "stakingPlanId_",
        type: "uint256",
      },
    ],
    name: "addPlan",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "getActivePlans",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "teamPlanId",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "subscriptionCost",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "reward",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "stakingThreshold",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "teamSize",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "stakingPlanId",
            type: "uint256",
          },
          {
            internalType: "bool",
            name: "isActive",
            type: "bool",
          },
        ],
        internalType: "struct ITeams.TeamPlan[]",
        name: "",
        type: "tuple[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "planId",
        type: "uint256",
      },
    ],
    name: "getPlan",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "teamPlanId",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "subscriptionCost",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "reward",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "stakingThreshold",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "teamSize",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "stakingPlanId",
            type: "uint256",
          },
          {
            internalType: "bool",
            name: "isActive",
            type: "bool",
          },
        ],
        internalType: "struct ITeams.TeamPlan",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getPlans",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "teamPlanId",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "subscriptionCost",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "reward",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "stakingThreshold",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "teamSize",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "stakingPlanId",
            type: "uint256",
          },
          {
            internalType: "bool",
            name: "isActive",
            type: "bool",
          },
        ],
        internalType: "struct ITeams.TeamPlan[]",
        name: "",
        type: "tuple[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    name: "getRoleAdmin",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "stakingPlanId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "getSufficientPlanIdByStakingAmount",
    outputs: [
      {
        internalType: "int256",
        name: "",
        type: "int256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getTimestamp",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "user",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "planId",
        type: "uint256",
      },
    ],
    name: "getUserSubscription",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "subscription",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "teamsFilled",
            type: "uint256",
          },
        ],
        internalType: "struct ITeams.Team",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "user",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "planId",
        type: "uint256",
      },
    ],
    name: "getUserTeamMembers",
    outputs: [
      {
        internalType: "address[]",
        name: "",
        type: "address[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "grantRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "user",
        type: "address",
      },
    ],
    name: "hasAnySubscription",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "hasRole",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "contractManagerAddress",
        type: "address",
      },
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "plans",
    outputs: [
      {
        internalType: "uint256",
        name: "teamPlanId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "subscriptionCost",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "reward",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "stakingThreshold",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "teamSize",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "stakingPlanId",
        type: "uint256",
      },
      {
        internalType: "bool",
        name: "isActive",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "proxiableUUID",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "renounceRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "revokeRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "planId",
        type: "uint256",
      },
    ],
    name: "subscribe",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "stakingPlanId",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "referrer",
        type: "address",
      },
      {
        internalType: "address",
        name: "member",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "tryToAddMember",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "planId",
        type: "uint256",
      },
      {
        internalType: "bool",
        name: "isActive",
        type: "bool",
      },
    ],
    name: "updatePlanActivity",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "planId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "reward",
        type: "uint256",
      },
    ],
    name: "updatePlanReward",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "planId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "stakingPlanId",
        type: "uint256",
      },
    ],
    name: "updatePlanStakingId",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "planId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "threshold",
        type: "uint256",
      },
    ],
    name: "updatePlanStakingThreshold",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "planId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "subscriptionCost",
        type: "uint256",
      },
    ],
    name: "updatePlanSubscriptionCost",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "planId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "size",
        type: "uint256",
      },
    ],
    name: "updatePlanTeamSize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "numDays",
        type: "uint256",
      },
    ],
    name: "updateSubscriptionPeriod",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newImplementation",
        type: "address",
      },
    ],
    name: "upgradeTo",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newImplementation",
        type: "address",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "upgradeToAndCall",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "user",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "planId",
        type: "uint256",
      },
    ],
    name: "userHasPlanSubscription",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "user",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "planId",
        type: "uint256",
      },
    ],
    name: "userHasSufficientStaking",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
] as const;

const _bytecode =
  "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";

type TeamsConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: TeamsConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class Teams__factory extends ContractFactory {
  constructor(...args: TeamsConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(overrides?: Overrides & { from?: string }): Promise<Teams> {
    return super.deploy(overrides || {}) as Promise<Teams>;
  }
  override getDeployTransaction(
    overrides?: Overrides & { from?: string }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  override attach(address: string): Teams {
    return super.attach(address) as Teams;
  }
  override connect(signer: Signer): Teams__factory {
    return super.connect(signer) as Teams__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): TeamsInterface {
    return new utils.Interface(_abi) as TeamsInterface;
  }
  static connect(address: string, signerOrProvider: Signer | Provider): Teams {
    return new Contract(address, _abi, signerOrProvider) as Teams;
  }
}
